"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chains = void 0;
var chains_1 = require("./lib/chains");
exports.Chains = (_a = {},
    _a[chains_1.Arbitrum.chainId] = chains_1.Arbitrum,
    _a[chains_1.Goerli.chainId] = chains_1.Goerli,
    _a[chains_1.Mainnet.chainId] = chains_1.Mainnet,
    _a[chains_1.Matic.chainId] = chains_1.Matic,
    _a[chains_1.Mumbai.chainId] = chains_1.Mumbai,
    _a[chains_1.Optimism.chainId] = chains_1.Optimism,
    _a);
